import Connections from '../../connections';
import {
  action, observable,
} from 'mobx';
import {
  getAllUsers,
  getNumberOfUsers,
  getDetailedStatistics,
} from '../../axios/statistics';
import {
  defaultUserStatistics,
  IPreRegisteredUser,
  IStatisticsStore,
  User,
  UserStatistics,
  RegistrationSources,
  UserDetailedChartLabel,
  UsersDetailedStatistcs,
  defaultDetailedData,
  AccessLevel
} from '../storeInterfaces/statisticsInterface';

export class StatisticsStore implements IStatisticsStore {
  @observable usersList: User[] = [];

  @observable adminsList: User[] = [];

  @observable usersStatistics: UserStatistics = defaultUserStatistics;

  @observable usersDetailedStatistics: UsersDetailedStatistcs = defaultDetailedData;

  @observable usersDetailedChartLabels: string [] = [];

  @observable loading = false;

  @observable totalPreRegisteredUsers = 1;

  @observable numberOfUsers = -1;

  @observable preRegisteredUsers: IPreRegisteredUser[] = [];

  @observable chartData: number[] = [
    defaultUserStatistics.registeredFromPortal,
    defaultUserStatistics.registeredFromMobile,
    defaultUserStatistics.registeredFromSportsReservation,
  ];

  @action
  public async getAllUsers(pageNumber: number, pageSize: number, adminUsers: boolean, filterValue?: string, isSuspended: boolean = false, accessLevel?: AccessLevel): Promise<void> {
    try {
      this.loading = true;
      const params = {
        pageNumber,
        pageSize,
        filterValue: filterValue || null,
        registrationStatus: 'registered',
        adminUsers,
        isSuspended,
        accessLevel,
      };
      const response = await Connections.wadiDeglaAxios.httpGet(getAllUsers, {
        params,
      });
      if (adminUsers) {
        this.adminsList = response.data.users;
      } else {
        this.usersList = response.data.users;
      }
      this.numberOfUsers = response.data.count;
    } catch (error) {
      console.log(error);
      throw Promise.reject(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async getUsersStatistics(): Promise<void> {
    try {
      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getNumberOfUsers);
      this.usersStatistics = response.data;

      if (this.usersStatistics.registeredFromPortal
          && this.usersStatistics.registeredFromMobile
          && this.usersStatistics.registeredFromSportsReservation
          && this.usersStatistics.registeredFromUnknown) {
        this.chartData = [
          this.usersStatistics.registeredFromPortal,
          this.usersStatistics.registeredFromMobile,
          this.usersStatistics.registeredFromSportsReservation,
          this.usersStatistics.registeredFromUnknown,
        ];
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  @action
  public async getUsersDetailedStatistics(from?: number | string | Date , to?: number | string | Date): Promise<void> {
    try {
      let params = {};
      if (from && to) {
         params = { from, to };
      }

      this.loading = true;
      const response = await Connections.wadiDeglaAxios.httpGet(getDetailedStatistics, {params});
      const { detailedStatisticsRespones , labels } = response.data;
      this.usersDetailedStatistics = {
        [RegistrationSources.mobileApp]: detailedStatisticsRespones[RegistrationSources.mobileApp],
        [RegistrationSources.webPortal]: detailedStatisticsRespones[RegistrationSources.webPortal],
        [RegistrationSources.sportsReservation]: detailedStatisticsRespones[RegistrationSources.sportsReservation],
        [RegistrationSources.unknown]: detailedStatisticsRespones[RegistrationSources.unknown],
      };
      this.usersDetailedChartLabels = this.restructureUserDetailedChartLabels(labels);
    } catch (error) {

      console.log(error);
      return Promise.reject();

    } finally {
      this.loading = false;
    }
  }


  @action
  public async getPreRegisteredUsers(pageNumber: number, pageSize: number, filterValue?: string): Promise<void> {
    try {
      this.loading = true;
      const params = {
        pageNumber,
        pageSize,
        filterValue: filterValue || null,
        registrationStatus: 'preRegistered',
      };
      const response = await Connections.wadiDeglaAxios.httpGet(getAllUsers, {
        params,
      });
      console.log(response.data);
      this.preRegisteredUsers = response.data.preRegisteredUsers;
      this.totalPreRegisteredUsers = response.data.totalPreRegisteredUsers;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  private restructureUserDetailedChartLabels(response: UserDetailedChartLabel []): string[] {
    const labels: string[] = [];
    response.forEach(res => {
      labels.push(`${
        res.day
      }/${
        res.month
      }/${
        res.year
      }`);
    });
    return labels;
  }

  clearUsersList(): void {
    this.usersList = [];
  }
}
